import { adaptError } from "../api/apiAdapters";
import {
  sendBlueprintRequestFromApi,
  submitBlueprintToApi,
  getTitleAndEscrowFromApi,
  getListingStageFromApi,
  dismissCardFromApi,
} from "../api/apiWrappers";
import {
  sentBlueprintRequest,
  fetchSendBlueprintRequestFailure,
  showSuccessToast,
  SubmitReqState,
  fetchgetTitleAndEscrowFailure,
  fetchDismissCardFailure,
  saveTitleAndEscrow,
  saveListingStage,
  getTitleAndEscrowStart,
  getListingStageStart,
} from "./creators";
import { tryCatchHandlr } from "../../../../shared/Utilities";
import { getAllPeopleAsThunk } from "../../../SideLeft/People/actions/thunks";
import { getDocumentsAsThunk } from "../../../Main/Docs/actions/thunks";

export const getTitleAndEscrow = (listingId) => async (dispatch) => {
  dispatch(getTitleAndEscrowStart());

  const req = getTitleAndEscrowFromApi(listingId);
  const [res, err] = await tryCatchHandlr(req);

  if (err) {
    dispatch(fetchgetTitleAndEscrowFailure(adaptError(err)));
    return;
  }
  const data = res.data;
  dispatch(saveTitleAndEscrow(data));
};

export const getListingStage = (listingId) => async (dispatch) => {
  dispatch(getListingStageStart());

  const req = getListingStageFromApi(listingId);
  const [res, err] = await tryCatchHandlr(req);

  if (err) {
    dispatch(
      saveListingStage({
        stage: {
          crm_transaction_status: "error",
          error_title: "Status temporarily unavailable",
          error_message: "Try again in a few minutes, or check the Blueprint portal directly.",
        },
        meta: { errors: [], warnings: [] },
      }),
    );
    return;
  }

  dispatch(saveListingStage(res.data));
};

export const dismissCard = (listingId) => async (dispatch) => {
  const req = dismissCardFromApi();
  const [res, err] = await tryCatchHandlr(req);

  if (err) {
    dispatch(fetchDismissCardFailure(adaptError(err)));
    return;
  }

  dispatch(getTitleAndEscrow(listingId));
};

export const sendBlueprintRequest = (listingId) => async (dispatch) => {
  const req = sendBlueprintRequestFromApi(listingId);
  const [res, err] = await tryCatchHandlr(req);

  if (err) {
    dispatch(fetchSendBlueprintRequestFailure(adaptError(err)));
    return;
  }

  dispatch(sentBlueprintRequest());
  dispatch(
    showSuccessToast({
      show: true,
      msg: "Request Sent! A representative from Blueprint should be reaching out to you shortly.",
    }),
  );
  setTimeout(() => {
    dispatch(showSuccessToast({ show: false, msg: "" }));
  }, 7000);
};

export const submitBlueprintAsThunk = (listingId, uuid, payload) => async (dispatch) => {
  const req = submitBlueprintToApi(listingId, payload);

  const [, err] = await tryCatchHandlr(req);

  if (err) {
    dispatch(
      SubmitReqState({
        isloading: false,
        isSucceed: false,
        isFailed: true,
        failureMsg:
          "There was an issue with submitting your form to Blueprint. Please reach out to support at (855) 427-4848 or start a new chat",
      }),
    );
    return;
  }
  dispatch(SubmitReqState({ isloading: false, isSucceed: true, isFailed: false, failureMsg: "" }));
  dispatch(getTitleAndEscrow(listingId));
  dispatch(getAllPeopleAsThunk(uuid));
  dispatch(getDocumentsAsThunk());
};
